import React, { useState, useEffect } from "react";

import { Menu, X, ArrowUpRight, Send, Mail, Phone, MapPin, Briefcase } from "lucide-react";
import { toast } from "sonner";

import Header from "@/components/Header";
import Careers from "@/components/Careers";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

import Hero from "../components/Hero";
import Stats from "../components/Stats";
import About from "../components/About";
import Services from "../components/Services";
import FactoryVideo from "../components/FactoryVideo";
import Products from "../components/sections/Products";
import Process from "../components/Process";
import Industries from "../components/Industries";
import Testimonials from "../components/Testimonials";

import CursorSpotlight from "../components/anim/CursorSpotlight";
import LogoMarquee from "../components/anim/LogoMarquee";

import {
  V4_COMPANY, V4_HERO_SLIDES, V4_STATS, V4_SERVICES, V4_PRODUCTS,
  V4_INDUSTRIES, V4_CERTIFICATIONS, V4_QUALITY_CERTS, V4_USPS, STOCK
} from "../data/siteV4";








export default function HomeV4() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Nikhan Controls";
  }, []);

  return (
    <div className="bg-white min-h-screen text-navy-900" data-testid="home-v4">
      <Header />
      <main>
        <Hero singlePage cinematic slides={V4_HERO_SLIDES} company={V4_COMPANY} />
        <Stats stats={V4_STATS} />
        <div id="about">
          <About singlePage parallax company={V4_COMPANY} usps={V4_USPS} qualityCerts={V4_QUALITY_CERTS} />
        </div>
        <div id="clients">
          <LogoMarquee
            items={V4_CERTIFICATIONS}
            eyebrow="Our Clients"
            titleTop="Trusted by brands"
            titleAccent="we're proud to serve."
            subtitle="From mobility leaders to consumer-electronics innovators, recognised brands across India partner with us to engineer and manufacture the products that power their business."
            footnote="A growing roster of long-term manufacturing & engineering partners"
            testId="clients-section"
          />
        </div>
        <div id="capabilities" className="[&>section]:!bg-white">
          <Services singlePage services={V4_SERVICES} />
        </div>
        <div id="factory" className="[&>section]:!bg-slate-50">
          <FactoryVideo posterOverride={STOCK.factory} stats={V4_STATS} />
        </div>
        <div id="products">
          <Products singlePage products={V4_PRODUCTS} />
        </div>
        <Process />
        <div id="industries">
          <CursorSpotlight color="rgba(245, 158, 11, 0.20)" size={620}>
            <Industries industries={V4_INDUSTRIES} />
          </CursorSpotlight>
        </div>
        <Testimonials />
        <CursorSpotlight color="rgba(245, 158, 11, 0.18)" size={620}>
          <Careers />
        </CursorSpotlight>
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
